module.exports = __webpack_public_path__ + "img/emergent-ventures-mercatus-center.c51c3eb4.png";